// sentry
import * as Sentry from '@sentry/browser'
import { Integrations } from '@sentry/tracing'

// providers
import envProvider from '@/providers/envProvider.ts'

const checkAvaiable = (func: Function) => {
  if (envProvider.isSentryEnabled) return func

  return () => {}
}

const init = () => {
  Sentry.init({
    dsn: envProvider.sentryDNS,
    release: envProvider.sentryRelease,
    integrations: [new Integrations.BrowserTracing()],
    environment: envProvider.env,
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
  })
}

export default {
  init: checkAvaiable(init),
}
